import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbDateParserFormatter, NgbDatepickerModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { ClickOutsideModule } from 'ng-click-outside';
import { SeasonRangePipe } from './pipes/season-range.pipe';
import { DaterangePickerComponent } from './components/daterange-picker/daterange-picker.component';
import { YearRangePickerComponent } from './components/year-range-picker/year-range-picker.component';
import { SimpleDaterangePickerComponent } from './components/simple-daterange-picker/simple-daterange-picker.component';
import { NgbDatePipe } from './pipes/ngb-date.pipe';
import { NgbDateCustomParserFormatter } from '@flipto/shared-discovery/formatters/ngb-custom-parser.formatter';

@NgModule({
    declarations: [
        DaterangePickerComponent,
        NgbDatePipe,
        SeasonRangePipe,
        YearRangePickerComponent,
        SimpleDaterangePickerComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ClickOutsideModule,
        NgbDatepickerModule,
        NgbTooltipModule
    ],
    providers: [
        SeasonRangePipe,
        { provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter }
    ],
    exports: [
        DaterangePickerComponent,
        YearRangePickerComponent,
        SimpleDaterangePickerComponent
    ]
})
export class DateRangePickerModule {
    constructor() {
    }
}
